const technoAEPData = {
  "JEE Advanced": {
    "Mock Test": {
      "2026": {
        chapters: [
          {
            name: "JEE Advanced (Q & A)",
            buttons: [
              { label: "Mock Test - I Paper - I (Question Paper)", file: "27.4.2026_JEE_Adv_PCM_Mock-I_Paper-I.pdf" },
              { label: "Mock Test - I Paper - I (Answer Sheet)", file: "Answer 27.4.2026_JEE_Adv_PCM_Mock-I_Paper-I.pdf" },
              { label: "Mock Test - I Paper - II (Question Paper)", file: "27.5.2026_JEE_Adv_PCM_Mock-I_Paper-II.pdf" },
              { label: "Mock Test - I Paper - II (Answer Sheet)", file: "Answer 27.5.2026_JEE_Adv_PCM_Mock-I_Paper-II.pdf" },
              { label: "Mock Test - II Paper - I (Question Paper)", file: "07.5.2026_JEE_Adv_PCM_Mock-2_Paper-I.pdf" },
              { label: "Mock Test - II Paper - I (Answer Sheet)", file: "Answer 07.5.2026_JEE_Adv_PCM_Mock-2_Paper-I.pdf" },
              { label: "Mock Test - II Paper - II (Question Paper)", file: "7.5.2026_JEE_Adv_PCM_Mock-2_Paper-2.pdf" },
              { label: "Mock Test - II Paper - II (Answer Sheet)", file: "Answer 7.5.2026_JEE_Adv_PCM_Mock-2_Paper-2.pdf" },
            ]
          }
        ]
      },
      "2025": {
        chapters: [
          {
            name: "JEE Advanced (Q & A)",
            buttons: [
              { label: "Mock Test - I Paper - I (Question Paper)", file: "Mock_1_Math_JEE_Adv.pdf" },
              { label: "Mock Test - I Paper - I (Answer Sheet)", file: "Answer Key_Math_JEE_Adv_MT-01.pdf" },
              { label: "Mock Test - I Paper - II (Question Paper)", file: "Mock_1_JEE_Adv (Paper II).pdf" },
              { label: "Mock Test - I Paper - II (Answer Sheet)", file: "Answer_Mock_1_JEE_Adv (Paper II).pdf" },
              { label: "Mock Test - II Paper - I (Question Paper)", file: "Mock_2_JEE_Adv-2 (Paper-I pcm).pdf" },
              { label: "Mock Test - II Paper - I (Answer Sheet)", file: "Answer Key_Mock_2_JEE_Adv_Paper-II.pdf" },
              { label: "Mock Test - II Paper - II (Question Paper)", file: "JEE_Advanced-mock 2_Paper-II_(PCM).pdf" },
              { label: "Mock Test - II Paper - II (Answer Sheet)", file: "Answer_JEE_Advanced-mock 2_Paper-II_(PCM).pdf" },
            ]
          }
        ]
      },

    }
  },
  "JEE Main": {
    "Mock Test Series": {
      "2025": {
        chapters: [
          {
            name: "Mock Test Series - I",
            buttons: [
              { label: "Mock Paper-1 (Question Paper)", file: "JEE_Main (Mock Paper-1).pdf" },
              { label: "Mock Paper-1 (Answer Sheet)", file: "JEE_Main (Mock Paper-1) Ans.pdf" }
            ]
          },
          {
            name: "Mock Test Series - II",
            buttons: [
              { label: "Mock Test - 1 (Question Paper)", file: "Mock_Test_Part_1 (JEE MAINS)_Question.pdf" },
              { label: "Mock Test - 1 (Answer Sheet)", file: "Answer Key_Mock_Part-1 (JEE MAINS).pdf" },
              { label: "Mock Test - 2 (Question Paper)", file: "Mock_Test _Part-2 (JEE Main).pdf" },
              { label: "Mock Test - 2 (Answer Sheet)", file: "Answer Key_Mock_Part_2 (JEE MAINS).pdf" },
              { label: "Mock Test - 3 (Question Paper)", file: "Mock_Test (JEE MAINS)_MT-03_PCM_Question.pdf" },
              { label: "Mock Test - 3 (Answer Sheet)", file: "Mock_Test (JEE MAINS)_PCM-03_Answer.pdf" },
              { label: "Mock Test - 4 (Question Paper)", file: "Mock_Test _JEE MAINS)_Question-04.pdf" },
              { label: "Mock Test - 4 (Answer Sheet)", file: "Answer Key_Mock_(JEE MAINS)-04.pdf" },
              { label: "Mock Test - 5 (Question Paper)", file: "Mock_Test _5 (JEE Main) _Question.pdf" },
              { label: "Mock Test - 5 (Answer Sheet)", file: "Answer Key_Mock_(JEE MAINS)_MT-05.pdf" }
            ]
          }
        ]
      },
      "2026": {
        chapters: [
          {
            name: "Mock Test Series - I (January 2026)",
            buttons: [
              { label: "Mock Test - 1 (Question Paper)", file: "Mock_Test 1_Series_1 (JEE Main).pdf" },
              { label: "Mock Test - 1 (Answer Sheet)", file: "Mock_Test 1_Series_1 (JEE Main)(Ans).pdf" },
              { label: "Mock Test - 2 (Question Paper)", file: "Mock_Test-II_Series_1 (JEE Main)_2026.pdf" },
              { label: "Mock Test - 2 (Answer Sheet)", file: "Mock_II_Series_I (JEE main) Ans.pdf" }
            ]
          },
          {
            name: "Mock Test Series - II (March 2026)",
            buttons: [
              { label: "Mock Test - 1 (Question Paper)", file: "16-3-26_Mock_Test-I (PCB)XII_ (JEE Main).pdf" },
              { label: "Mock Test - 1 (Answer Sheet)", file: "16-3-26 Answer_Mock_Test-I_PCM_XII_ (JEE Main).pdf" },
              { label: "Mock Test - 2 (Question Paper)", file: "Mock_2_JEE_Mains_Series_2_2026_PCM.pdf" },
              { label: "Mock Test - 2 (Answer Sheet)", file: "Mock_2_JEE_Mains_Series_2_2026_ANS.pdf" },
              { label: "Mock Test - 3 (Question Paper)", file: "27.3.2026_JEE Main Mock_3(PCM)_XII.pdf" },
              { label: "Mock Test - 3 (Answer Sheet)", file: "Mock_3_JEE_Mains_Series_2_2026_ANS.pdf" }
            ]
          }
        ]
      }
    },
    "MMT Series": {
      "Class XII": {
        "2025": {
          chapters: [
            {
              name: "JEE MAIN (Class-XII)",
              buttons: [
                { label: "Mock Test - I (Question Paper)", file: "JEE_Main_XII_I_PCM (Question).pdf" },
                { label: "Mock Test - I (Answer Sheet)", file: "JEE_Main_XII_1_PCM (Ans).pdf" },
                { label: "Mock Test - II (Question Paper)", file: "JEE_Main_XII_II_PCM (Question).pdf" },
                { label: "Mock Test - II (Answer Sheet)", file: "JEE_Main_XII_II_PCM (Ans).pdf" },
                { label: "Mock Test - IV (Question Paper)", file: "JEE_Main_XII_IV_PCM (Question).pdf" },
                { label: "Mock Test - IV (Answer Sheet)", file: "JEE_Main_XII_IV_PCM (Ans).pdf" },
                { label: "Mock Test - V (Question Paper)", file: "JEE_Main_XII_V_PCM (Question).pdf" },
                { label: "Mock Test - V (Answer Sheet)", file: "JEE_Main_XII_V_PCM (Ans).pdf" },
                { label: "Mock Test - VI (Question Paper)", file: "JEE_Main_XII_VI_PCM (Question).pdf" },
                { label: "Mock Test - VI (Answer Sheet)", file: "JEE_Main_XII_VI_PCM (Ans).pdf" }
              ]
            }
          ]
        }
      },
      "Class XI": {
        "2025": {
          chapters: [
            {
              name: "JEE MAIN (Class-XI)",
              buttons: [
                { label: "Mock Test - I (Question Paper)", file: "JEE_Main-XI_I_PCM_Question.pdf" },
                { label: "Mock Test - I (Answer Sheet)", file: "ANS_JEE_Main_XI_I_PCM.pdf" },
                { label: "Mock Test - II (Question Paper)", file: "JEE_Main-XI_II_PCM_Question.pdf" },
                { label: "Mock Test - II (Answer Sheet)", file: "ANS_JEE_Main_XI_II_PCM.pdf" },
                { label: "Mock Test - IV (Question Paper)", file: "JEE_Main-XI_IV_PCM_Question.pdf" },
                { label: "Mock Test - IV (Answer Sheet)", file: "Ans_JEE_Main_XI_IV_PCM.pdf" },
                { label: "Mock Test - V (Question Paper)", file: "JEE_Main_XI_V_PCM_Question.pdf" },
                { label: "Mock Test - V (Answer Sheet)", file: "Ans_JEE_Main_XI_V_PCM.pdf" },
                { label: "Mock Test - VI (Question Paper)", file: "JEE_Main-XI_VI_PCM_Question.pdf" },
                { label: "Mock Test - VI (Answer Sheet)", file: "ANS_JEE_Main_XI_VI_PCM.pdf" },
                { label: "Mock Test - VII (Question Paper)", file: "JEE_Main-XI_VII_PCM_Question.pdf" },
                { label: "Mock Test - VII (Answer Sheet)", file: "ANS_JEE_Main_XI_VII_PCM.pdf" }
              ]
            }
          ]
        }
      }
    }
  },
  "NEET": {
    "Mock Test Series": {
      "2025": {
        chapters: [
          {
            name: "NEET Mock Test",
            buttons: [
              { label: "Mock Test - 1 (Question Paper)", file: "NEET_Mock Test_Set-1 (Paper-1).pdf" },
              { label: "Mock Test - 1 (Answer Sheet)", file: "Answer Key_NEET_MT-01_PCB.pdf" },
              { label: "Mock Test - 2 (Question Paper)", file: "NEET_Mock_Test-2_Question.pdf" },
              { label: "Mock Test - 2 (Answer Sheet)", file: "Answer Key_NEET_MT-02_PCB.pdf" },
              { label: "Mock Test - 3 (Question Paper)", file: "NEET_Mock_Test-3_PCB_Question.pdf" },
              { label: "Mock Test - 3 (Answer Sheet)", file: "Answer Key_NEET_MT-03_PCB.pdf" },
              { label: "Mock Test - 4 (Question Paper)", file: "NEET_Mock_Test-4_PCB_Question.pdf" },
              { label: "Mock Test - 4 (Answer Sheet)", file: "Answer Key_NEET_MT-04_PCB.pdf" },
              { label: "Mock Test - 5 (Question Paper)", file: "NEET_Mock_Test-5_PCB_Question_Final.pdf" },
              { label: "Mock Test - 5 (Answer Sheet)", file: "Answer Key_NEET_MT-05_PCB.pdf" }
            ]
          }
        ]
      },
      "2026": {
        chapters: [
          {
            name: "NEET Mock Test",
            buttons: [
              { label: "Mock Test - 1 (Question Paper)", file: "NEET_Mock_1_PCB_1.04.2026.pdf" },
              { label: "Mock Test - 1 (Answer Sheet)", file: "Answer Key_NEET_Mock_1_PCB_1.04.2026.pdf" },
              { label: "Mock Test - 2 (Question Paper)", file: "08-04-2026_NEET_Mock_2_PCB.pdf" },
              { label: "Mock Test - 2 (Answer Sheet)", file: "Answer Key_NEET_Mock_2_PCB_31.04.2026.pdf" },
              { label: "Mock Test - 3 (Question Paper)", file: "16-04-2026_NEET_Mock_3_PCB.pdf" },
              { label: "Mock Test - 3 (Answer Sheet)", file: "Answer Key_NEET_Mock_3_PCB (16-4-26_).pdf" },
              { label: "Mock Test - 4 (Question Paper)", file: "22.4.2026_NEET-4_PCB.pdf" },
              { label: "Mock Test - 4 (Answer Sheet)", file: "Answer_22.4.2026_NEET-4_PCB.pdf" }
            ]
          }
        ]
      }
    },
    "MMT Series": {
      "Class XII": {
        "2025": {
          chapters: [
            {
              name: "NEET (Class-XII)",
              buttons: [
                { label: "Mock Test - I (Question Paper)", file: "NEET_XII_I_PCB (Question).pdf" },
                { label: "Mock Test - I (Answer Sheet)", file: "NEET_XII_I_PCB (Answer).pdf" },
                { label: "Mock Test - II(Question Paper)", file: "NEET_XII_II_PCB (Question).pdf" },
                { label: "Mock Test - II(Answer Sheet)", file: "NEET_XII_II_PCB (Answer).pdf" },
                { label: "Mock Test - IV (Question Paper)", file: "NEET_XII_IV_PCB (Question).pdf" },
                { label: "Mock Test - IV (Answer Sheet)", file: "NEET_XII_IV_PCB (Answer).pdf" },
                { label: "Mock Test - V (Question Paper)", file: "NEET_XII_V_PCB (Question).pdf" },
                { label: "Mock Test - V (Answer Sheet)", file: "NEET_XII_V_PCB (Answer).pdf" },
                { label: "Mock Test - VI (Question Paper)", file: "NEET_XII_VI_PCB (Question).pdf" },
                { label: "Mock Test - VI (Answer Sheet)", file: "NEET_XII_VI_PCB (Answer).pdf" }
              ]
            }
          ]
        }
      },
      "Class XI": {
        "2025": {
          chapters: [
            {
              name: "NEET (Class-XI)",
              buttons: [
                { label: "Mock Test - I (Question Paper)", file: "NEET_XI_I_PCB (Question).pdf" },
                { label: "Mock Test - I (Answer Sheet)", file: "NEET_XI_I_PCB (Answer).pdf" },
                { label: "Mock Test - II(Question Paper)", file: "NEET_XI_II_PCB (Question).pdf" },
                { label: "Mock Test - II(Answer Sheet)", file: "NEET_XI_II_PCB (Answer).pdf" },
                { label: "Mock Test - IV (Question Paper)", file: "NEET_XI_IV_PCB (Question).pdf" },
                { label: "Mock Test - IV (Answer Sheet)", file: "NEET_XI_IV_PCB (Answer).pdf" },
                { label: "Mock Test - V (Question Paper)", file: "NEET_XI_V_PCB (Question).pdf" },
                { label: "Mock Test - V (Answer Sheet)", file: "NEET_XI_V_PCB (Answer).pdf" },
                { label: "Mock Test - VI (Question Paper)", file: "NEET_XI_VI_PCB (Question).pdf" },
                { label: "Mock Test - VI (Answer Sheet)", file: "NEET_XI_VI_PCB (Answer).pdf" },
                { label: "Mock Test - VII (Question Paper)", file: "NEET_XI_VII_PCB (Question).pdf" },
                { label: "Mock Test - VII (Answer Sheet)", file: "NEET_XI_VII_PCB (Answer).pdf" }
              ]
            }
          ]
        }
      }
    }
  },
  "Class XII": {
    "Question Bank": {
      "2026 - 2027": {
        chapters: [
          {
            name: "Physics (Class-XII)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_XII_(Physic) 2025-26.pdf` }
            ]
          },
          {
            name: "Chemistry (Class-XII)",
            buttons: [
              { label: "Question Bank", file: `Question_Bank_XII_Chemistry.pdf` }
            ]
          },
          {
            name: "Maths (Class-XII)",
            buttons: [
              { label: "Question Bank", file: `QUESTION BANK_Mathematics_XII.pdf` }
            ]
          },
          {
            name: "Biology (Class-XII)",
            buttons: [
              { label: "Question Bank", file: `Question_Bank_XII_Biology.pdf` }
            ]
          }
        ]
      }
    },
    "MPT": {
      "2025 - 2026": {
        chapters: [
          {
            name: "MPT-1 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "MPT-01_XII_7-7-2025 Question.pdf" },
              { label: "Answer Sheet", file: "MPT-01_XII_PCMB_ANSWER.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "MPT-2_Class-XII_ PCMB 7-8-2025.pdf" },
              { label: "Answer Sheet", file: "ANSWER_MPT_2_XII_PCMB 7-8-2025.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "MPT_03_XII_(PCMB)_22.08.2025.pdf" },
              { label: "Answer Sheet", file: "ANSWER_MPT_3_Cl-XII (PCMB).pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "Mth_MPT-4_Cl-XII_ PCMB.pdf" },
              { label: "Answer Sheet", file: "MPT_4_Cl-XII_ANSWER_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "12.12.2025_MPT-5_Cl-XII_ PCMB.pdf" },
              { label: "Answer Sheet", file: "MPT_5_Cl-XII_ANSWER_PCMB.pdf" }
            ]
          }
        ]
      },
      "2024 - 2025": {
        chapters: [
          {
            name: "MPT-1 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_1_XII_(22-04-24).pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_1_XII.pdf" },
              { label: "Solution Paper", file: "solution_mpt_1_XII.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_2_XII.pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_2_xii.pdf" },
              { label: "Solution Paper", file: "solution_mpt_2_XII.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_3_xii.pdf" },
              { label: "Answer Sheet", file: "all_answer_sheet_xii_mpt_3.pdf" },
              { label: "Solution Paper", file: "mpt_solution_xii_set_3.pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-4_XII (24-7-24).pdf" },
              { label: "Answer Sheet", file: "All_Answer_Sheet_MPT-4_XII.pdf" },
              { label: "Solution Paper", file: "Solution_MPT-4_XII_30.7.2024.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-5_XII.pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_5_XII.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-5_XII.pdf" }
            ]
          },
          {
            name: "MPT-6 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "question_mpt-6_XII.pdf" },
              { label: "Answer Sheet", file: "all_answer_mpt-6_XII.pdf" },
              { label: "Solution Paper", file: "solution_mpt_6_XII.pdf" }
            ]
          },
          {
            name: "MPT-7 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT_7_XII.pdf" },
              { label: "Answer Sheet", file: "All_Answer_MPT_7_XII.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-7_XII.pdf" }
            ]
          },
          {
            name: "MPT-8 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "Question_XII-(MPT-8).pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_8_XII.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-8_XII.pdf" }
            ]
          },
          {
            name: "MPT-9 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-9_XII.pdf" },
              { label: "Answer Sheet", file: "All_Answer_MPT_9_XII.pdf" },
              { label: "Solution Paper", file: "Solution MPT-9_XII_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-10 (Class-XII)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT_10_XII_PCMB.pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_10_XII_PCMB.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-10_XII_PCMB.pdf" }
            ]
          }
        ]
      }
    },
    "Mock Test Series": {
      "2025 - 2026": {
        chapters: [
          {
            name: "CBSE Mock Test (Class-XII)",
            buttons: [
              { label: "Mock Test-I (Physics)", file: "Mock_XII (Physics)_Part-1_2025.pdf" },
              { label: "Mock Test-II (Physics)", file: "Mock_2_Physics_XII_2025.pdf" },
              { label: "Mock Test-I (Biology)", file: "Mock_XII_(Biology) Part-I.pdf" },
              { label: "Mock Test-II (Biology)", file: "Mock Paper-2_Bio_XII_2025-26.pdf" },
              { label: "Mock Test-III (Biology)", file: "Mock_3_Biology_XII.pdf" },
              { label: "Mock Test-IV (Biology)", file: "Mock_Test_4_Biology_XII.pdf" },
              { label: "Mock Test-I (Chemistry)", file: "Mock-XII_(Chemistry)_Part_1.pdf" },
              { label: "Mock Test-II (Chemistry)", file: "Mock-XII_(Chemistry)_Part_II.pdf" },
              { label: "Mock Test-III (Chemistry)", file: "Mock_3_Chemistry_XII.pdf" },
              { label: "Mock Test-IV (Chemistry)", file: "Mock_Test_IV_Chemistry_XII.pdf" },
              { label: "Mock Test-I (Math)", file: "Mock__XII (Math) Part_1_2025.pdf" },
              { label: "Mock Test-II (Math)", file: "Mock_2_Math_XII.pdf" },
              { label: "Mock Test-III (Math)", file: "Mock_Math_XII_Set_3_Decmbr.pdf" },
              { label: "Mock Test-IV (Math)", file: "Mock_Math_XII_Set_4.pdf" }
            ]
          }
        ]
      },
      "2024 - 2025": {
        chapters: [
          {
            name: "JEE MAIN Mock (2024-25)",
            buttons: [
              { label: "Test-1 (Question Paper)", file: "mock_test_part_1_jee_mains_question.pdf" },
              { label: "Test-1 (Answer Sheet)", file: "answer_key_mock_part_1_jee_mains.pdf" },
              { label: "Test-1 (Solution Paper)", file: "mock_test_part_1_jee_mains_solution.pdf" },
              { label: "Test-2 (Question Paper)", file: "mock_test_part_2_jee_mains.pdf" },
              { label: "Test-2 (Answer Sheet)", file: "answer_key_mock_part_2_jee_mains.pdf" },
              { label: "Test-2 (Solution Paper)", file: "mock_test_part_2_jee_mains_solution.pdf" },
              { label: "Test-3 (Question Paper)", file: "mock_test_jee_mains_mt_03_pcm_question.pdf" },
              { label: "Test-3 (Answer Sheet)", file: "mock_test_jee_mains_pcm_03_answer.pdf" },
              { label: "Test-3 (Solution Paper)", file: "mock_test_(jee_mains)_PCM-03_Solution.pdf" },
              { label: "Test-4 (Question Paper)", file: "mock_test_jee_mains_question_04.pdf" },
              { label: "Test-4 (Answer Sheet)", file: "answer_key_mock_jee_mains_04.pdf" },
              { label: "Test-4 (Solution Paper)", file: "mock_test_jee_mains_04_solution.pdf" }
            ]
          }
        ]
      }
    },
    "Suggested Questions For CBSE Exam": {
      "2025 - 2026": {
        chapters: [
          {
            name: "Physics (Class-XII)",
            buttons: [
              { label: "Ray Optics, Level - 1", file: "physics-ray-optics-class-xii-level-1.pdf" },
              { label: "Ray Optics, Level - 2", file: "physics-ray-optics-class-xii-level-2.pdf" },
              { label: "Semiconductor Electronics, Level - 1", file: "physics-semiconductor-electronics-class-xii-level-1.pdf" },
              { label: "Semiconductor Electronics, Level - 2", file: "physics-semiconductor-electronics-class-xii-level-2.pdf" },
              { label: "Electric Charges, Level - 1", file: "CBSC_NCRT_XII-Ch-1(Electric..)Phy_L1.pdf" },
              { label: "Electric Charges, Level - 2", file: "CBSC_NCRT_XII-Ch-1(Electric..)Phy_L2.pdf" },
              { label: "Dual nature of Radiation & Matter, Level - 1", file: "CBSC_NCRT_Phy_XII (Dual nature of Radia.._)L1_Ch-3.pdf" },
              { label: "Dual nature of Radiation & Matter, Level - 2", file: "CBSC_NCRT_Phy_XII (Dual nature of Radia.._)L2_Ch-3.pdf" },
              { label: "Atoms and Nuclei, Level - 1", file: "CBSC_NCRT_Phy_XII (Atoms and...)L1_Ch-8.pdf" },
              { label: "Atoms and Nuclei, Level - 2", file: "CBSC_NCRT_Phy_XII (Atoms and...)L2_Ch-8.pdf" },
              { label: "Magnetic Effect of Current, Level - 1", file: "NCERT_Physics_XII_Magnetic effect_(L-1).pdf" },
              { label: "Magnetic Effect of Current, Level - 2", file: "NCERT_Physics_XII_Magnetic effect_(L-2).pdf" },
              { label: "Wave Optics, Level - 1", file: "CBSE_NCERT_Phy_XII(Wave Optics) Chap-07-L-1.pdf" },
              { label: "Wave Optics, Level - 2", file: "CBSE_NCERT_Phy_XII(Wave Optics) Chap-07-L-2.pdf" },
              { label: "Current Electricity, Level - 1", file: "CBSE_NCERT_Physics_XII_Current Electricity)CH - 4_L-1.pdf" },
              { label: "Current Electricity, Level - 2", file: "CBSE_NCERT_Physics_XII_Current Electricity)CH - 4_L-2.pdf" },
              { label: "Electro Magnetic Induction, Level - 1", file: "CBSE_NCERT_Phy_XII_(Electro Magnetic..)CH - 6_L-1.pdf" },
              { label: "Electro Magnetic Induction, Level - 2", file: "CBSE_NCERT_Phy_XII_(Electro Magnetic..)CH - 6_L-2.pdf" }
            ]
          },
          {
            name: "Chemistry (Class-XII)",
            buttons: [
              { label: "Solutions, Level - 1", file: "class-xii-chemistry-solutions-L-1.pdf" },
              { label: "Solutions, Level - 2", file: "class-xii-chemistry-solutions-L-2.pdf" },
              { label: "Electrochemistry, Level - 1", file: "class-xii-chemistry-electrochemistry-L-1.pdf" },
              { label: "Electrochemistry, Level - 2", file: "class-xii-chemistry-electrochemistry-L-2.pdf" },
              { label: "Aldehydes, Ketones & Carboxylic Acids, Level - 1", file: "CBSE_NCER_Chem_XII (Aldehydes, Ketones)_L_1_Ch-8.pdf" },
              { label: "Aldehydes, Ketones & Carboxylic Acids, Level - 2", file: "NCERT_Chem_XII (Aldehydes, Ketones)L_2_Ch-8.pdf" },
              { label: "Chemical Kinetics, Level - 1", file: "CBSE NCET_Chem_XII (Chemical Kinetic)L_1.pdf" },
              { label: "Chemical Kinetics, Level - 2", file: "CBSE NCERT_Chem_XII (Chemical Kinetic)_L_2.pdf" },
              { label: "'d' & 'f' block elements, Level - 1", file: "CBSE_NCERT_Chemistry_XII_5.2.26_ 'd' & 'f' block.pdf" },
              { label: "'d' & 'f' block elements, Level - 2", file: "CBSE_NCERT_Chemistry_XII_9.2.26_ Ch-'d' & 'f' block_L-2.pdf" },
              { label: "Coordinate Chemistry, Level - 1", file: "CBSE_NCERT_Chem_XII_(Co-ordinate )CH - 5_L-1.pdf" },
              { label: "Coordinate Chemistry, Level - 2", file: "CBSE_NCERT_Chem_XII_(Co-ordinate )CH - 5_L-2.pdf" },
              { label: "Haloalkanes & haloarches, Level - 1", file: "CBSE_NCERT_Chem_XII (_Haloalkanes...),CH-6_L-1.pdf" },
              { label: "Haloalkanes & haloarches, Level - 2", file: "CBSE_NCERT_Chem_XII (_Haloalkanes...),CH-6_L-2.pdf" },
              { label: "Alcohol, Phenol & Ether, Level - 1", file: "CBSE_NCERT_Chem_XII__(Alcohol, phenol & Ether) CH-7_L-1.pdf" },
              { label: "Alcohol, Phenol & Ether, Level - 2", file: "CBSE_NCERT_Chem_XII__(Alcohol, phenol & Ether) CH-7_L-2.pdf" },
              { label: "Amines, Level - 1", file: "CBSE-NCERT_CHEM_XII(Amines)L_1_Ch-9.pdf" },
              { label: "Amines, Level - 2", file: "CBSE-NCERT_CHEM_XII(Amines)L_2_Ch-9.pdf" },
              { label: "Biomolecules, Level - 1", file: "CBSC_NCRT_Biomolecules_Chem_XII_L1_Ch-10.pdf" },
              { label: "Biomolecules, Level - 2", file: "CBSC_NCRT_Biomolecules_Chem_XII_L2_Ch-10.pdf" }
            ]
          },
          {
            name: "Maths (Class-XII)",
            buttons: [
              { label: "Differential Calculus, Level - 1, 2", file: "differential-calculus-XII-L-1-L-2.pdf" },
              { label: "Differential Equations, Level - 1, 2", file: "differential-equation-XII-L-1-L-2.pdf" },
              { label: "Integral Calculus, Level - 1, 2", file: "integral-calculus-XII-L-1-L-2.pdf" },
              { label: "Inverse Trigonometric, Level - 1, 2", file: "CBSE_NCERT_Math_XII_CH-2 (Inverse Trigonometric)L-1&2 .pdf" },
              { label: "Vector Algebra, Level - 1, 2", file: "CBSE_NCERT_Math_XII (Vector Algebra)(Ch-10)_L-1&2.pdf" },
              { label: "Relations & Functions, Level - 1, 2", file: "CBSE_NCERT_Math_XII_(Relation....)CH - 1_L-1 & 2.pdf" },
              { label: "Case Based Questions", file: "CBSE_NCERT_Math_XII_(Case BaseQuestion).pdf" },
              { label: "Determinant, Level - 1, 2", file: "NCERT_XII_Ch-4_L_1 &_L_2_Determinant.pdf" },
              { label: "Probability, Level - 1, 2", file: "CBSE_NCERT_Math_XII_CH_13(Probability) L 1 & 2.pdf" },
              { label: "Dimentional Geometry, Level - 1, 2", file: "CBSE_NCERT_Math_XII_CH - 11_3 Dimentional Geometry.pdf" },
              { label: "Matrix, Level - 1, 2", file: "CBSC_NCRT_Math_XII (Matrix_Math)L-1&2 Ch-3.pdf" },
              { label: "Linear Programming Problems, Level -1 & 2", file: "CBSE_NCERT_Math_X_CH - 12_L-1 & 2.pdf" },
              { label: "Case Base Ques, Level -1 & 2", file: "CBSE_NCERT_Math_XII_L-1 & 2 - Case Base Ques.pdf" },
              { label: "Assertion & Reason, SET - I", file: "Assertion-Reasoning_Set_1_XII.pdf" },
              { label: "Assertion & Reason, SET - II", file: "Math_Assertion-Reasoning_Set_2_XII.pdf" },
              { label: "Assertion & Reason, SET - III", file: "Math_Assertion-Reasoning_Set_3_XII.pdf" }
            ]
          },
          {
            name: "Biology (Class-XII)",
            buttons: [
              { label: "Sexual Reproduction in Flowering Plants, Level - 1", file: "class-xii-sexual-reproduction-in-flowering-plants-level-1.pdf" },
              { label: "Sexual Reproduction in Flowering Plants, Level - 2", file: "class-xii-sexual-reproduction-in-flowering-plants-level-2.pdf" },
              { label: "Principles of Inheritance and Variation, Level - 1", file: "Class-XII-biology-principles-of-inheritance-and-variation-level-1.pdf" },
              { label: "Principles of Inheritance and Variation, Level - 2", file: "Class-XII-biology-principles-of-inheritance-and-variation-level-2.pdf" },
              { label: "Human Health & Diseases, Level - 1", file: "class-xii-biology-human-health-L-1.pdf" },
              { label: "Human Health & Diseases, Level - 2", file: "class-xii-biology-human-health-L-2.pdf" },
              { label: "Reproduction, Level - 1", file: "CBSC_NCRT_Biology-XIII_Ch-2&3_(Reproduction...)-L1.pdf" },
              { label: "Reproduction, Level - 2", file: "CBSC_NCRT_Biology-XIII_Ch-2&3_(Reproduction...)-L2.pdf" },
              { label: "Evolution, Level - 1", file: "CBSC_NCRT_Biology-XII_Chap-06 (Evolution)-L1.pdf" },
              { label: "Evolution, Level - 2", file: "CBSC_NCRT_Biology_XII_Chap-06 (Evolution)-L2.pdf" },
              { label: "Organisms and Populations, Level - 1", file: "CBSC_NCRT_Bio_XII (Organisms & Populations)L1_Ch-11.pdf" },
              { label: "Organisms and Populations, Level - 2", file: "CBSC_NCRT_Bio_XII (Organisms & Populations)L2_Ch-11.pdf" },
              { label: "Microbes in Human Welfare, Level - 1", file: "CBSE_NCERT_Bio_XII_(Microbes in Human Welfare) (L-1).pdf" },
              { label: "Microbes in Human Welfare, Level - 2", file: "CBSE_NCERT_Bio_XII_(Microbes in Human Welfare) (L-2).pdf" },
              { label: "Biotechnology and Its Applications, Level - 1", file: "CBSC_NCRT_Bio_XII (Biotechnology....)L1_Ch-10.pdf" },
              { label: "Biotechnology and Its Applications, Level - 2", file: "CBSC_NCRT_Bio_XII (Biotechnology....)L2_Ch-10.pdf" },
              { label: "Ecosystem, Level - 1", file: "NCERT_Biology_XII_Ecosystem_(L-1).pdf" },
              { label: "Ecosystem, Level - 2", file: "NCERT_Biology_XII_Ecosystem_(L-2).pdf" },
              { label: "Biodiversity and Conservation, Level - 1", file: "CBSC_NCRT_Bio_XII (Biodiversity..)L1_Ch-13.pdf" },
              { label: "Biodiversity and Conservation, Level - 2", file: "CBSC_NCRT_Bio_XII (Biodiversity..)L2_Ch-13.pdf" },
              { label: "Molecular Basis of Inheritance, Level - 1", file: "NCERT_Biology_XII(Molecular Basis)L-1.pdf" },
              { label: "Molecular Basis of Inheritance, Level - 2", file: "NCERT_Biology_XII(Molecular Basis)L-2.pdf" },
              { label: "Principles and Processes, Level - 1", file: "CBSE-NCERT_Biology-XII(Principles...)Chap-9_L-1.pdf" },
              { label: "Principles and Processes, Level - 2", file: "CBSE-NCERT_Biology-XII(Principles...)Chap-9_L-2.pdf" }
            ]
          }
        ]
      }
    },
    "Trips And Tricks": {
      "2025 - 2026": {
        chapters: [
          {
            name: "Class - XII Tricks & Tips",
            buttons: [
              { label: "Math (Chap - 1)", file: "Trips & Tricks_Math_Ch_1_XII.pdf" },
              { label: "Math (Chap - 7)", file: "Tips & Tricks_Math_XII_CH - 7.pdf" },
              { label: "Chemistry (Chap - 1)", file: "Tips & Tricks_Chem_XII_Chap_1.pdf" },
              { label: "Biology (Chap - 4)", file: "Tips & Trick (Bio-XII) Chap-04.pdf" },
              { label: "Biology (Chap - 5)", file: "Tips & Trick (Bio-XII) Chap-05.pdf" },
              { label: "Physics (Chap - Variation of a quantity)", file: "Tricks &Tips_Phy_XII_variation of a quantity.pdf" }
            ]
          }
        ]
      }
    }
  },
  "Class XI": {
    "MPT": {
      "2025 - 2026": {
        chapters: [
          {
            name: "MPT-1 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "MPT-1_Cl-XI_7-7-2025 Question.pdf" },
              { label: "Answer Sheet", file: "MPT_01_XI_PCMB_ANSWER.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "MPT-2_Class-XI_ PCMB 7-8-2025.pdf" },
              { label: "Answer Sheet", file: "MPT_2_XI_ANSWER_PCMB 7-8-2025.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "MPT-3_Cl-XI (PCMB)_22-8-2025 .pdf" },
              { label: "Answer Sheet", file: "ANSWER_MPT-3_XI(PCMB) 22-8-25.pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "MPT-4_Cl-XI_ PCMB.pdf" },
              { label: "Answer Sheet", file: "MPT_4_Cl-XI_ANSWER_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "12.12.2025_MPT-5_Cl-XI_ PCMB.pdf" },
              { label: "Answer Sheet", file: "MPT_5_Cl-XI_ANSWER_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-6 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "16-01-26-MPT_6_Cl-XI_PCMB.pdf" },
              { label: "Answer Sheet", file: "16-01-26-MPT_6_Cl-XI_ANSWER_PCMB.pdf" }
            ]
          }
        ]
      },
      "2024 - 2025": {
        chapters: [
          {
            name: "MPT-1 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_1_XI_(22-04-24).pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_1_XI.pdf" },
              { label: "Solution Paper", file: "solution_mpt_1_XI.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_2_XI.pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_2_xi.pdf" },
              { label: "Solution Paper", file: "solution_mpt_2_XI.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_3_xi.pdf" },
              { label: "Answer Sheet", file: "all_answer_sheet_xi_mpt_3.pdf" },
              { label: "Solution Paper", file: "mpt_solution_xi_set_3.pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-4_XI (24-07-24).pdf" },
              { label: "Answer Sheet", file: "All_Answer_MPT_4_XI.pdf" },
              { label: "Solution Paper", file: "Solution_MPT-4_XI.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-5_XI.pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_5_XI.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-5_XI.pdf" }
            ]
          },
          {
            name: "MPT-6 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_6_XI.pdf" },
              { label: "Answer Sheet", file: "all_answer_mpt_6_XI.pdf" },
              { label: "Solution Paper", file: "solutions_mpt_6_All_XI.pdf" }
            ]
          },
          {
            name: "MPT-7 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT_7_XI.pdf" },
              { label: "Answer Sheet", file: "All_Answer_MPT_7_XI.pdf" },
              { label: "Solution Paper", file: "Solutions-MPT-7_All_XI.pdf" }
            ]
          },
          {
            name: "MPT-8 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "Question_XI-(MPT-8).pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_8_XI.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-8_XI.pdf" }
            ]
          },
          {
            name: "MPT-9 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-9_XI.pdf" },
              { label: "Answer Sheet", file: "All_Answer_MPT_9_XI.pdf" },
              { label: "Solution Paper", file: "Solution MPT-9_XI_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-10 (Class-XI)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT_10_XI_PCMB.pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_10_XI_PCMB.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-10_XI_PCMB.pdf" }
            ]
          }
        ]
      }
    },
    "Question Bank": {
      "2026 - 2027": {
        chapters: [
          {
            name: "Physics (Class-XI)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_XI_Physics 2026-27.pdf` }
            ]
          },
          {
            name: "Chemistry (Class-XI)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_XI_Chemistry 2025-26.pdf` }
            ]
          },
          {
            name: "Maths (Class-XI)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_XI_Math 2026-27.pdf` }
            ]
          },
          {
            name: "Biology (Class-XI)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_XI_(Biology) 2026-27.pdf` }
            ]
          }
        ]
      }
    }
  },
  "Class VIII": {
    "MPT": {
      "2025 - 2026": {
        chapters: [
          {
            name: "MPT-1 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "MPT-1_VIII-7-7-2025(QUESTION).pdf" },
              { label: "Answer Sheet", file: "MPT_1_VIII_ANSWER_7-7-2025.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "MPT-2_Cl-VIII_ PCMB (7-8-2025).pdf" },
              { label: "Answer Sheet", file: "ANSWER_MPT-2_VIII_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "MPT-3_VIII (PCMB)-22-8-2025.pdf" },
              { label: "Answer Sheet", file: "MPT_3_VIII_ANSWER (PCMB)22.08.2025.pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "30.10.2025_MPT_04_VIII_PCMB.pdf" },
              { label: "Answer Sheet", file: "30.10.2025_MPT_4_VIII_ANS_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "12.12.2025_MPT_05_VIII_PCMB.pdf" },
              { label: "Answer Sheet", file: "12.12.2025_MPT_5_VIII_ANS_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-6 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "MPT-6_VIII-16-01-2026(QUESTION).pdf" },
              { label: "Answer Sheet", file: "MPT_6_VIII_ANSWER_16-01-2026.pdf" }
            ]
          }
        ]
      },
      "2024 - 2025": {
        chapters: [
          {
            name: "MPT-1 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_1_VIII_(22-04-24).pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_1_VIII.pdf" },
              { label: "Solution Paper", file: "solution_mpt_1_VIII.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_2_VIII.pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_2_viii.pdf" },
              { label: "Solution Paper", file: "solution_mpt_2_VIII.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_3_viii.pdf" },
              { label: "Answer Sheet", file: "all_answer_sheet_viii_mpt_3.pdf" },
              { label: "Solution Paper", file: "mpt_solution_viii_set_3.pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-VIII)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT_4_(G)_VIII_(24-07-24).pdf" },
              { label: "Answer Sheet (G)", file: "All_Answer_MPT_4(G)_VIII.pdf" },
              { label: "Solution Paper (G)", file: "Solution_MPT-4_Math_VIII_Set-G_30.7.2024.pdf" },
              { label: "Question Paper (S)", file: "Question_MPT_4_(S)_VIII_(24-07-24).pdf" },
              { label: "Answer Sheet (S)", file: "All_Answer_MPT_4(S)_VIII.pdf" },
              { label: "Solution Paper (S)", file: "Solution_MPT-4_Math_VIII_Set-S_30.7.2024.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-VIII)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT-5_VIII_G.pdf" },
              { label: "Answer Sheet (G)", file: "All-Answer-MPT_5_VIII_G.pdf" },
              { label: "Solution Paper (G)", file: "Solutions_MPT-5_PCMB_VIII_G.pdf" },
              { label: "Question Paper (S)", file: "Question_MPT-5_VIII_S.pdf" },
              { label: "Answer Sheet (S)", file: "All-Answer-MPT_5_VIII_S.pdf" },
              { label: "Solution Paper (S)", file: "Solutions_MPT-5_PCMB_VIII_S.pdf" }
            ]
          },
          {
            name: "MPT-6 (Class-VIII)",
            buttons: [
              { label: "Question Paper (G)", file: "question_mpt-6_VIII(G).pdf" },
              { label: "Answer Sheet (G)", file: "all_answer_mpt_6_VIII_G.pdf" },
              { label: "Solution Paper (G)", file: "solution_mpt_6_(viii_G).pdf" },
              { label: "Question Paper (S)", file: "question_mpt-6_VIII(S).pdf" },
              { label: "Answer Sheet (S)", file: "all_answer_mpt_6_VIII_S.pdf" },
              { label: "Solution Paper (S)", file: "solution_mpt_6_(viii_S).pdf" }
            ]
          },
          {
            name: "MPT-7 (Class-VIII)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT_7_VIII_G.pdf" },
              { label: "Answer Sheet (G)", file: "All_Answer_MPT_7_VIII_G.pdf" },
              { label: "Solution Paper (G)", file: "Solution-MPT-7_(viii-G).pdf" },
              { label: "Question Paper (S)", file: "Question_MPT-7_VIII_S.pdf" },
              { label: "Answer Sheet (S)", file: "All_Answer_MPT_7_VIII_S.pdf" },
              { label: "Solution Paper (S)", file: "Solution-MPT-7_(viii-S).pdf" }
            ]
          },
          {
            name: "MPT-8 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "Question_VIII-(MPT_8).pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_8_VIII.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-8_Cl-VIII.pdf" }
            ]
          },
          {
            name: "MPT-9 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-9_VIII.pdf" },
              { label: "Answer Sheet", file: "All_Answer_MPT_9_VIII.pdf" },
              { label: "Solution Paper", file: "Solution MPT-9_VIII_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-10 (Class-VIII)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT_10_VIII_PCMB.pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_10_VIII_PCMB.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-10_VIII_PCMB.pdf" }
            ]
          }
        ]
      }
    },
    "Question Bank": {
      "2026 - 2027": {
        chapters: [
          {
            name: "Physics (Class-VIII)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_VIII_(Physic) 2026-27.pdf` }
            ]
          },
          {
            name: "Chemistry (Class-VIII)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_VIII_(Chemistry) 2026-27.pdf` }
            ]
          },
          {
            name: "Maths (Class-VIII)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_VIII_(Math) 2026-27.pdf` }
            ]
          },
          {
            name: "Biology (Class-VIII)",
            buttons: [
              { label: "Question Bank", file: `Question Bank_VIII_(Biology) 2026-27.pdf` }
            ]
          }
        ]
      }
    }
  },
  "Class IX": {
    "MPT": {
      "2025 - 2026": {
        chapters: [
          {
            name: "MPT-1 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "MPT-1_Cl-IX_QUESTION_7-7-2025.pdf" },
              { label: "Answer Sheet", file: "MPT-1_Cl-IX_ANSWER_7-7-2025.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "MPT-2_Cl-IX_PCMB)_7-8-2025.pdf" },
              { label: "Answer Sheet", file: "ANSWER_MPT-2_IX_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "MPT_03_IX (PCMB)_22.08.2025.pdf" },
              { label: "Answer Sheet", file: "ANSWER_MPT-3_IX_(PCMB) 22-8-25.pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "30.10.2025_MPT_04_IX_PCMB.pdf" },
              { label: "Answer Sheet", file: "30.10.2025_MPT_4_IX_ANS_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "12.12.2025_MPT_05_IX_PCMB.pdf" },
              { label: "Answer Sheet", file: "12.12.2025_MPT_5_IX_ANS_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-6 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "16.01.2026_MPT_6_IX_PCMB.pdf" },
              { label: "Answer Sheet", file: "16.01.2026_MPT_6_IX_ANS_PCMB.pdf" }
            ]
          }
        ]
      },
      "2024 - 2025": {
        chapters: [
          {
            name: "MPT-1 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_1_ix_(22-04-24).pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_1_IX.pdf" },
              { label: "Solution Paper", file: "solution_mpt_1_IX.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_2_IX.pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_2_ix.pdf" },
              { label: "Solution Paper", file: "solution_mpt_2_IX.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_3_ix.pdf" },
              { label: "Answer Sheet", file: "all_answer_sheet_ix_mpt_3.pdf" },
              { label: "Solution Paper", file: "mpt_solution_ix_set_3.pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-IX)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT-4_(G)_IX_(24.7.2024).pdf" },
              { label: "Answer Sheet (G)", file: "All_Answer_Sheet_MPT-4(G)_IX.pdf" },
              { label: "Solution Paper (G)", file: "Solution_MPT-4_Math_IX_Set-G_30.7.2024.pdf" },
              { label: "Question Paper (S)", file: "Question_MPT-4_(S)_IX_(24.07.2024).pdf" },
              { label: "Answer Sheet (S)", file: "All_Answer_Sheet_MPT-4(S)_IX.pdf" },
              { label: "Solution Paper (S)", file: "Solution_MPT-4_Math_IX_Set-S_30.7.2024.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-IX)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT-5_IX_G.pdf" },
              { label: "Answer Sheet (G)", file: "All-Answer-MPT_5_IX_G.pdf" },
              { label: "Solution Paper (G)", file: "Solutions_MPT-5_Math_IX_G.pdf" },
              { label: "Question Paper (S)", file: "Question_MPT-5_IX_S.pdf" },
              { label: "Answer Sheet (S)", file: "All-Answer-MPT_5_IX_S.pdf" },
              { label: "Solution Paper (S)", file: "Solutions_MPT-5_Math_IX_S.pdf" }
            ]
          },
          {
            name: "MPT-6 (Class-IX)",
            buttons: [
              { label: "Question Paper (G)", file: "question_mpt-6_IX(G).pdf" },
              { label: "Answer Sheet (G)", file: "all_answer_mpt_6_IX_G.pdf" },
              { label: "Solution Paper (G)", file: "solutions_mpt_6_All_IX_G.pdf" },
              { label: "Question Paper (S)", file: "question_mpt_6_IX(S).pdf" },
              { label: "Answer Sheet (S)", file: "all_answer_mpt_6_IX_S.pdf" },
              { label: "Solution Paper (S)", file: "solutions_mpt_6_All_IX_S.pdf" }
            ]
          },
          {
            name: "MPT-7 (Class-IX)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT-7_IX_G.pdf" },
              { label: "Answer Sheet (G)", file: "All_Answer_MPT_7_IX_G.pdf" },
              { label: "Solution Paper (G)", file: "Solutions-MPT-7_All_IX(G).pdf" },
              { label: "Question Paper (S)", file: "Question_MPT-7_IX_S.pdf" },
              { label: "Answer Sheet (S)", file: "All_Answer_MPT_7_IX_S.pdf" },
              { label: "Solution Paper (S)", file: "Solutions-MPT-7_All_IX(S).pdf" }
            ]
          },
          {
            name: "MPT-8 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "Question_IX-(MPT_8).pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_8_IX.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-8_Cl-IX.pdf" }
            ]
          },
          {
            name: "MPT-9 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-9_IX.pdf" },
              { label: "Answer Sheet", file: "All_Answer_MPT_9_IX.pdf" },
              { label: "Solution Paper", file: "Solution MPT-9_IX_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-10 (Class-IX)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT_10_IX_PCMB.pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_10_IX_PCMB.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-10_IX_PCMB.pdf" }
            ]
          }
        ]
      }
    },
    "Question Bank": {
      "2026 - 2027": {
        chapters: [
          {
            name: "Physics (Class-IX)",
            buttons: [
              { label: "Question Bank", file: `QUESTION BANK_Physics_IX.pdf` }
            ]
          },
          {
            name: "Chemistry (Class-IX)",
            buttons: [
              { label: "Question Bank", file: `QUESTION BANK_Chemistry_IX.pdf` }
            ]
          },
          {
            name: "Maths (Class-IX)",
            buttons: [
              { label: "Question Bank", file: `QUESTION BANK_Mathematics_IX.pdf` }
            ]
          },
          {
            name: "Biology (Class-IX)",
            buttons: [
              { label: "Question Bank", file: `QUESTION BANK_Biology_IX.pdf` }
            ]
          }
        ]
      }
    }
  },
  "Class X": {
    "MPT": {
      "2025 - 2026": {
        chapters: [
          {
            name: "MPT-1 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "MPT-1_Cl-X_Question_7-7-2025.pdf" },
              { label: "Answer Sheet", file: "MPT-1_Cl-X_ANSWER_7-7-2025.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "MPT-2_Cl-X_ PCMB (7-8-2025).pdf" },
              { label: "Answer Sheet", file: "ANSWER_MPT-2_X_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "MPT-3_X_(PCMB) 22.8.2025.pdf" },
              { label: "Answer Sheet", file: "ANSWER_MPT_3_Cl-X (PCMB).pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "MPT-4_Cl-X_ PCMB.pdf" },
              { label: "Answer Sheet", file: "MPT-4_Cl-X_ANSWER_PCMB.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "12.12.2025_MPT-5_Cl-X_ PCMB.pdf" },
              { label: "Answer Sheet", file: "MPT-5_Cl-X_ANSWER_PCMB.pdf" }
            ]
          }
        ]
      },
      "2024 - 2025": {
        chapters: [
          {
            name: "MPT-1 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_1_X_(22-04-24).pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_1_X.pdf" },
              { label: "Solution Paper", file: "solution_mpt_1_X.pdf" }
            ]
          },
          {
            name: "MPT-2 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_2_X.pdf" },
              { label: "Answer Sheet", file: "answer_sheet_mpt_1_X.pdf" },
              { label: "Solution Paper", file: "solution_mpt_1_X.pdf" }
            ]
          },
          {
            name: "MPT-3 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "question_mpt_3_x.pdf" },
              { label: "Answer Sheet", file: "all_answer_sheet_x_mpt_3.pdf" },
              { label: "Solution Paper", file: "mpt_solution_x_set_3.pdf" }
            ]
          },
          {
            name: "MPT-4 (Class-X)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT_4_(G)_X_(24-07-24).pdf" },
              { label: "Answer Sheet (G)", file: "All_Answer_MPT_4(G)_X.pdf" },
              { label: "Solution Paper (G)", file: "Solutions_MPT-4_X_G.pdf" },
              { label: "Question Paper (S)", file: "Question_MPT_4_(S)_X_(24-07-24).pdf" },
              { label: "Answer Sheet (S)", file: "All_Answer_MPT_4(S)_X.pdf" },
              { label: "Solution Paper (S)", file: "Solutions_MPT-4_X_S.pdf" }
            ]
          },
          {
            name: "MPT-5 (Class-X)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT-5_X_G.pdf" },
              { label: "Answer Sheet (G)", file: "All-Answer-MPT_5_X_G.pdf" },
              { label: "Solution Paper (G)", file: "Solutions_MPT-5_Math_X_G.pdf" },
              { label: "Question Paper (S)", file: "Question_MPT-5_X_S.pdf" },
              { label: "Answer Sheet (S)", file: "All-Answer-MPT_5_X_S.pdf" },
              { label: "Solution Paper (S)", file: "Solutions_MPT-5_Math_X_(S).pdf" }
            ]
          },
          {
            name: "MPT-6 (Class-X)",
            buttons: [
              { label: "Question Paper (G)", file: "question_mpt-6_X(G).pdf" },
              { label: "Answer Sheet (G)", file: "all_answer_mpt_6_X_G.pdf" },
              { label: "Solution Paper (G)", file: "solution_mpt_6_X_Set_G.pdf" },
              { label: "Question Paper (S)", file: "question_mpt_6_X(S).pdf" },
              { label: "Answer Sheet (S)", file: "all_answer_mpt_6_X_S.pdf" },
              { label: "Solution Paper (S)", file: "solution_mpt_6_X_Set_S.pdf" }
            ]
          },
          {
            name: "MPT-7 (Class-X)",
            buttons: [
              { label: "Question Paper (G)", file: "Question_MPT-7_X_G.pdf" },
              { label: "Answer Sheet (G)", file: "All_Answer_MPT_7_X_G.pdf" },
              { label: "Solution Paper (G)", file: "Solutions-MPT-7_X_G.pdf" },
              { label: "Question Paper (S)", file: "Question_MPT_7_X_S.pdf" },
              { label: "Answer Sheet (S)", file: "All_Answer_MPT_7_X_S.pdf" },
              { label: "Solution Paper (S)", file: "Solutions-MPT-7_X_S.pdf" }
            ]
          },
          {
            name: "MPT-8 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "Question_X-(MPT_8).pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_8_X.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-8_Cl-X.pdf" }
            ]
          },
          {
            name: "MPT-9 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT-9_X.pdf" },
              { label: "Answer Sheet", file: "All_Answer_MPT_9_X.pdf" },
              { label: "Solution Paper", file: "Solution MPT-9_Cl-X.pdf" }
            ]
          },
          {
            name: "MPT-10 (Class-X)",
            buttons: [
              { label: "Question Paper", file: "Question_MPT_10_X_PCMB.pdf" },
              { label: "Answer Sheet", file: "All-Answer-MPT_10_X_PCMB.pdf" },
              { label: "Solution Paper", file: "Solution-MPT-10_X_PCMB.pdf" }
            ]
          }
        ]
      }
    },
    "Question Bank": {
      "2026 - 2027": {
        chapters: [
          {
            name: "Physics (Class-X)",
            buttons: [
              { label: "Question Bank", file: `Question_Bank_X_Physics.pdf` }
            ]
          },
          {
            name: "Chemistry (Class-X)",
            buttons: [
              { label: "Question Bank", file: `Question_Bank_X_Chemistry.pdf` }
            ]
          },
          {
            name: "Maths (Class-X)",
            buttons: [
              { label: "Question Bank", file: `Question_Bank_X_Mathematics.pdf` }
            ]
          },
          {
            name: "Biology (Class-X)",
            buttons: [
              { label: "Question Bank", file: `Question_Bank_X_Biology.pdf` }
            ]
          }
        ]
      }
    },
    "Suggested Questions For CBSE Exam": {
      "2025 - 2026": {
        chapters: [
          {
            name: "Math (Class-X)",
            buttons: [
              { label: "Quadratic Equations, Level - 1", file: "maths-class-x-quadratic-equations-L-1.pdf" },
              { label: "Quadratic Equations, Level - 2", file: "maths-class-x-quadratic-equations-L-2.pdf" },
              { label: "Triangles, Level - 1", file: "maths-class-x-triangles-L-1.pdf" },
              { label: "Triangles, Level - 2", file: "maths-class-x-triangles-L-2.pdf" },
              { label: "Arithmetic Progression, Level - 1", file: "class-x-arithmetic-progression-L-1.pdf" },
              { label: "Arithmetic Progression, Level - 2", file: "class-x-arithmetic-progression-L-2.pdf" },
              { label: "Circles, Level - 1", file: "class-x-circles-L-1.pdf" },
              { label: "Circles, Level - 2", file: "class-x-circles-L-2.pdf" },
              { label: "Real Numbers , Level - 1", file: "CBSE_NCERT_Math_X_CH-1 (Real No.)_L-1.pdf" },
              { label: "Real Numbers , Level - 2", file: "CBSE_NCERT_Math_X_CH-1 (Real No.)_L-2.pdf" },
              { label: "Introduction to Trigonometry , Level - 1", file: "CBSE_NCERT_Math_X_Ch-8 (Introduction...)L_1.pdf" },
              { label: "Introduction to Trigonometry , Level - 2", file: "CBSE_NCERT_Math_X_CH-8 (Introduction of trigonomety)L-2.pdf" },
              { label: "Coordinate Geometry , Level - 1", file: "CBSE_NCERT_Math_X_CH - 7_L-1.pdf" },
              { label: "Coordinate Geometry , Level - 2", file: "CBSE_NCERT_Math_X_CH - 7_L-2.pdf" },
              { label: "Surface Areas & Volumes , Level - 1", file: "CBSE_NCERT_Math_X_CH - 12_L-1.pdf" },
              { label: "Surface Areas & Volumes , Level - 2", file: "CBSE_NCERT_Math_X_CH - 12_L-2.pdf" },
              { label: "Statistics , Level - 1", file: "NCERT_Math_X (Statistics)-L_1_Ch-13.pdf" },
              { label: "Statistics , Level - 2", file: "NCERT_Math_X(Statistics)L_2_Ch-13.pdf" },
              { label: "Polynomials , Level - 1", file: "CBSE_NCERT_Math_X_(Polynomials)CH - 2_L-1.pdf" },
              { label: "Polynomials , Level - 2", file: "CBSE_NCERT_Math_X_(Polynomials)CH - 2_L-2.pdf" },
              { label: "Heights & Distances , Level - 1", file: "CBSE_NCERT_Math_X(Heights...) CH - 9_L-1.pdf" },
              { label: "Heights & Distances , Level - 2", file: "CBSE_NCERT_Math_X(Heights...) CH - 9_L-2.pdf" },
              { label: "Probability , Level - 1", file: "CBSE_NCERT_Math_X (Probability)CH - 14_L-1.pdf" },
              { label: "Probability , Level - 2", file: "CBSE_NCERT_Math_X (Probability)CH - 14_L-2.pdf" },
              { label: "Pair of Linear Equations in two Variabbles , Level - 1", file: "CBSE_NCERT_Math_X (Pair of Linear...) CH - 3_L-1.pdf" },
              { label: "Pair of Linear Equations in two Variabbles , Level - 2", file: "CBSE_NCERT_Math_X (Pair of Linear...) CH - 3_L-2.pdf" },
              { label: "Area Related to Circles , Level - 1", file: "CBSC_NCRT_Math_X(Area related....)L1_Ch-11.pdf" },
              { label: "Area Related to Circles, Level - 2", file: "CBSC_NCRT_Math_X(Area related....)L2_Ch-11.pdf" }
            ]
          }
        ]
      }
    },
    "CBSE Mock Test 2025 - 26": {
      "2025 - 2026": {
        chapters: [
          {
            name: "Class-X",
            buttons: [
              { label: "Mock Paper-I (PCB)", file: "Mock_Text_I_X (PCB) 2025-26.pdf" },
              { label: "Mock Paper-II (PCB)", file: "Mock_Test_II_X (PCB) 2025-26.pdf" },
              { label: "Mock Paper-III (PCB)", file: "Mock_Test_III_X (PCB) 2025-26.pdf" },
              { label: "Mock Paper-I (MATH)", file: "Mock_Test_I_X (Math) 2025-26.pdf" },
              { label: "Mock Paper-II (MATH)", file: "Mock_Test_II_X (Math) 2025-26.pdf" },
              { label: "Mock Paper-III (MATH)", file: "Mock_Test_III_X (Math) 2025-26.pdf" },
              { label: "Mock Paper-IV (MATH)", file: "Mock_Test_IV_X (Math) 2025-26.pdf" }
            ]
          }
        ]
      }
    },
    "Tips & Tricks": {
      "2025 - 2026": {
        chapters: [
          {
            name: "Class - X",
            buttons: [
              { label: "Math - X (Chap - Trigonometry)", file: "Math_X_Tricks &Tips_(B. Exam).pdf" }
            ]
          }
        ]
      }
    }
  }
};
;

export default technoAEPData;
